import React , {Component} from 'react';
import {Modal} from 'react-bootstrap';
import '../css/spinner.css';
import '../css/signin.css';
import '../css/main.css';

class Spinner extends Component { 
    render(){
        return(
            <div className="center-Container">
                <div class="lds-default absolute-Center">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                </div>
            </div>
            
        )
    }
}

export default Spinner;